import React from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const InfoModal = ({ isOpen, onClose, title, message }) => {
  if (!isOpen) {
    return null;
  }

  const isError = title.toLowerCase() === 'error';
  const Icon = isError ? FaTimesCircle : FaCheckCircle;
  const iconColor = isError ? 'text-red-500' : 'text-green-500';
  const buttonClass = isError ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700';

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50 transition-opacity duration-300">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md mx-4 text-center transform scale-95 hover:scale-100 transition-transform duration-300">
        <div className="flex justify-center items-center mb-6">
          <Icon className={`text-6xl ${iconColor}`} />
        </div>
        <h3 className="text-2xl font-bold text-gray-800 mb-2">{title || 'Information'}</h3>
        <p className="text-gray-600 mb-8 px-4">{message || 'An unspecified event occurred.'}</p>
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className={`px-8 py-3 text-white rounded-full font-semibold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 ${buttonClass}`}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
